import { Injectable } from '@angular/core';
import { UserUpdateDetailsRequest } from '@classifieds-sell/datalayer';
import { select, Store } from '@ngrx/store';
import * as UserActions from './user.actions';
import * as UserFeature from './user.reducer';
import * as UserSelectors from './user.selectors';

@Injectable()
export class UserFacade {
    userDetails$ = this.store.pipe(select(UserSelectors.getUserDetails));
    memberSummary$ = this.store.pipe(select(UserSelectors.getMemberSummary));
    topUpAccountStatus$ = this.store.pipe(
        select(UserSelectors.getTopUpAccountStatus)
    );
    updateUserDetailsResponse$ = this.store.pipe(
        select(UserSelectors.updateUserDetailsResponse)
    );

    constructor(private store: Store<UserFeature.UserPartialState>) {}

    init() {
        this.store.dispatch(UserActions.getUserDetails());
    }

    reloadUserDetails() {
        this.store.dispatch(UserActions.reloadUserDetails());
    }

    updateUserDetails(userUpdateDetailsRequest: UserUpdateDetailsRequest) {
        this.store.dispatch(
            UserActions.updateUserDetails({ userUpdateDetailsRequest })
        );
    }
}
